import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ORG_APPLY_URL, ORG_APPLY_HELPER_COPY } from "@/lib/organisationSignup";

interface CTASectionProps {
  title?: string;
  description?: string;
}

const CTASection = ({
  title = "See the operational platform in action",
  description = "Book a demo to see how Privacy360 brings assessments, records, consent, contracts, AI governance, training and evidence into one operational system tailored to your programme.",
}: CTASectionProps) => (
  <section className="py-20 gradient-cta">
    <div className="container text-center">
      <h2 className="text-3xl md:text-4xl font-semibold text-primary-foreground mb-4">{title}</h2>
      <p className="text-primary-foreground/80 text-lg mb-8 max-w-xl mx-auto">{description}</p>
      <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-start sm:justify-center">
        <Link to="/book-demo">
          <Button size="lg" variant="secondary" className="text-foreground font-semibold px-8">
            Book Demo
          </Button>
        </Link>
        <div className="flex flex-col items-center gap-2">
          <a href={ORG_APPLY_URL}>
            <Button size="lg" className="bg-transparent border border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 px-8">
              Apply for an account
            </Button>
          </a>
          
        </div>
        <Link to="/contact">
          <Button size="lg" className="bg-transparent border border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 px-8">
            Talk to Sales
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default CTASection;
